import styled from 'styled-components';
import { theme } from '../../../global';

export const CaseContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 840px;
  flex-direction: column;
  margin: auto;
  gap: ${theme.spacings.s24};
  padding: ${theme.spacings.s40} 0;

  @media (max-width: 900px) {
    width: 500px;
    padding: ${theme.spacings.s24} 0;
  }

  @media (max-width: 500px) {
    width: 343px;
    padding: ${theme.spacings.s24} 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Button = styled.div`
  width: ${theme.spacings.s48};
  height: ${theme.spacings.s48};
  border-radius: ${theme.spacings.s32};
  border: 1px solid ${theme.colors.lightPurple};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const TagsContainer = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  span {
    border: 0.94px solid ${theme.colors.lightPurple};
    border-radius: ${theme.spacings.s32};
    padding: ${theme.spacings.s8};
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 12px;
    line-height: 14.63px;
    color: #53555f;
    margin: 0;
  }
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
  width: 100%;
  margin: ${theme.spacings.s16} 0;
`;

export const MenuContainer = styled.div`
  ol {
    gap: ${theme.spacings.s8};

    a {
      font-family: 'Montserrat';
      font-weight: 400;
      font-size: 14px;
      text-decoration: underline;
      text-decoration-style: solid;

      &:hover {
        background-color: transparent;
        color: ${theme.colors.secondaryText};
      }
    }

    span {
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 14px;
      color: ${theme.colors.blue};
    }
  }
`;

export const Title = styled.h3`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.s16};

  p {
    font-family: 'Montserrat';
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;

    strong {
      font-family: 'Montserrat';
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const GamesTitle = styled.h3`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 20px;
`;

